export enum HeaderTabs {
    KycPresets = 'kycPresets',
    KycFields = 'kycFields',
}
